import { render, staticRenderFns } from "./ThreadChatDrawer.vue?vue&type=template&id=ded88e3c"
import script from "./ThreadChatDrawer.vue?vue&type=script&lang=js"
export * from "./ThreadChatDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports